/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-11-17 10:58:18
 * @LastEditors: sj
 * @LastEditTime: 2022-01-13 10:29:55
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import {
  PartnerPlatformList,
  addPartnerPlatform,
  openCancelPartnerPlatform,
  PartnerPlatformListParams,
  addPartnerPlatformParams,
} from '../../services/partnerPlatform'

//  合作机构列表
export const getPartnerPlatformList = createAsyncThunk<
  any,
  PartnerPlatformListParams,
  RootThunkApi
>('stand/getPartnerPlatformList', async (params, api) => {
  return sendAsync(PartnerPlatformList(params), api)
})

//  修改新增合作平台
export const isAddPartnerPlatform = createAsyncThunk<
  any,
  addPartnerPlatformParams,
  RootThunkApi
>('stand/isAddPartnerPlatform', async (params, api) => {
  return sendAsync(addPartnerPlatform(params), api)
})

//   开启/禁用合作平台
export const isOpenPartnerPlatform = createAsyncThunk<
  any,
  string,
  RootThunkApi
>('stand/isOpenPartnerPlatform', async (id, api) => {
  return sendAsync(openCancelPartnerPlatform(id), api)
})
